<template>
  <div>


    <div class="seldashboardRow row">


      <div class="col-sm-6 col-lg-3">
        <div class="card text-white bg-flat-color-1">
          <div class="card-body pb-0">
            <div class="dropdown float-right d-none">
              <button class="btn bg-transparent dropdown-toggle theme-toggle text-light" type="button" id="dropdownMenuButton" data-toggle="dropdown">
                <i class="fa fa-cog"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div class="dropdown-menu-content">
                  <a class="dropdown-item" href="#">Action</a>
                  <a class="dropdown-item" href="#">Another action</a>
                  <a class="dropdown-item" href="#">Something else here</a>
                </div>
              </div>
            </div>
            <h4 class="mb-0">
              <span class="count">{{lastMonthIncome}}</span>
            </h4>
            <p class="text-light">{{$t('seldashboard.lastMonthIncome')}}</p>

            <div class="chart-wrapper px-0 d-none" style="height:70px;" height="70">
              <canvas id="widgetChart1"></canvas>
            </div>

          </div>

        </div>
      </div>
      <!--/.col-->

      <div class="col-sm-6 col-lg-3">
        <div class="card text-white bg-flat-color-4">
          <div class="card-body pb-0">
            <div class="dropdown float-right d-none">
              <button class="btn bg-transparent dropdown-toggle theme-toggle text-light" type="button" id="dropdownMenuButton1" data-toggle="dropdown">
                <i class="fa fa-cog"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <div class="dropdown-menu-content">
                  <a class="dropdown-item" href="#">Action</a>
                  <a class="dropdown-item" href="#">Another action</a>
                  <a class="dropdown-item" href="#">Something else here</a>
                </div>
              </div>
            </div>
            <h4 class="mb-0">
              <span class="count">{{actualDayIncome}}</span>
            </h4>
            <p class="text-light">{{$t('seldashboard.actualDayIncome')}}</p>

            <div class="chart-wrapper px-3 d-none" style="height:70px;" height="70">
              <canvas id="widgetChart4"></canvas>
            </div>

          </div>
        </div>
      </div>
      <!--/.col-->
      <div class="col-sm-6 col-lg-3">
        <div class="card text-white bg-flat-color-3">
          <div class="card-body pb-0">
            <div class="dropdown float-right d-none">
              <button class="btn bg-transparent dropdown-toggle theme-toggle text-light" type="button" id="dropdownMenuButton3" data-toggle="dropdown">
                <i class="fa fa-cog"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton3">
                <div class="dropdown-menu-content">
                  <a class="dropdown-item" href="#">Action</a>
                  <a class="dropdown-item" href="#">Another action</a>
                  <a class="dropdown-item" href="#">Something else here</a>
                </div>
              </div>
            </div>
            <h4 class="mb-0">
              <span class="count"><span class="text-danger">{{actualDayIncomeByCash}}</span></span> / <span class="count"><span class="text-primary">{{actualDayIncomeByCard}}</span> / <span class="count"><span class="text-success">{{actualDayIncomeByTransfer}}</span></span></span>
            </h4>
            <p class="text-light "><span class="">{{$t('seldashboard.actualDayIncome')}}</span><br> <span class="small"><span class="text-danger">{{$t('seldashboard.byCash')}}</span> / <span class="text-primary">{{$t('seldashboard.byCard')}}</span> / <span class="text-success">{{$t('seldashboard.byTransfer')}}</span></span> </p>

          </div>

          <div class="chart-wrapper px-0 d-none" style="height:70px;" height="70">
            <canvas id="widgetChart3"></canvas>
          </div>
        </div>
      </div>


      <div class="col-sm-6 col-lg-3">
        <div class="card text-white bg-flat-color-2">
          <div class="card-body pb-0">
            <div class="dropdown float-right d-none">
              <button class="btn bg-transparent dropdown-toggle theme-toggle text-light" type="button" id="dropdownMenuButton2" data-toggle="dropdown">
                <i class="fa fa-cog"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                <div class="dropdown-menu-content">
                  <a class="dropdown-item" href="#">Action</a>
                  <a class="dropdown-item" href="#">Another action</a>
                  <a class="dropdown-item" href="#">Something else here</a>
                </div>
              </div>
            </div>
            <h4 class="mb-0">
              <span class="count">{{actualMonthIncome}}</span>
            </h4>
            <p class="text-light">{{$t('seldashboard.actualMonthIncome')}}</p>

            <div class="chart-wrapper px-0 d-none" style="height:70px;" height="70">
              <canvas id="widgetChart2"></canvas>
            </div>

          </div>
        </div>
      </div>
      <!--/.col-->


    </div>


    <!--<div class="seldashboardRow row">-->

      <!--<div class="col-xl-3 col-lg-6">-->
        <!--<div class="card">-->
          <!--<div class="card-body">-->
            <!--<div class="stat-widget-one">-->
              <!--<div class="stat-icon dib"><i class="ti-money text-success border-success"></i></div>-->
              <!--<div class="stat-content dib">-->
                <!--<div class="stat-text">{{$t('seldashboard.lastMonthIncome')}}</div>-->
                <!--<div class="stat-digit">{{lastMonthIncome}}</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->


      <!--<div class="col-xl-3 col-lg-6">-->
        <!--<div class="card">-->
          <!--<div class="card-body">-->
            <!--<div class="stat-widget-one">-->
              <!--<div class="stat-icon dib"><i class="ti-user text-primary border-primary"></i></div>-->
              <!--<div class="stat-content dib">-->
                <!--<div class="stat-text">{{$t('seldashboard.totalBuyers')}}</div>-->
                <!--<div class="stat-digit">{{totalBuyers}}</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div class="col-xl-3 col-lg-6">-->
        <!--<div class="card">-->
          <!--<div class="card-body">-->
            <!--<div class="stat-widget-one">-->
              <!--<div class="stat-icon dib"><i class="ti-layout-grid2 text-warning border-warning"></i></div>-->
              <!--<div class="stat-content dib">-->
                <!--<div class="stat-text">{{$t('seldashboard.totalProducts')}}</div>-->
                <!--<div class="stat-digit">{{totalProducts}}</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div class="col-xl-3 col-lg-6">-->
        <!--<div class="card">-->
          <!--<div class="card-body">-->
            <!--<div class="stat-widget-one">-->
              <!--<div class="stat-icon dib"><i class="ti-layout-grid2 text-danger border-danger"></i></div>-->
              <!--<div class="stat-content dib">-->
                <!--<div class="stat-text">{{$t('seldashboard.totalStores')}}</div>-->
                <!--<div class="stat-digit">{{totalStores}}</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->


    <!--</div>-->


    <div class="seldashboardRow row">

      <!--<div class="col-xl-3 col-lg-6">-->
      <div class="col-12">
        <section class="card">
          <div class="twt-feed blue-bg">
            <div class="corner-ribon black-ribon">
              <!--<img src="/img/logo.png">-->
              <!--<i class="fa fa-twitter"></i>-->
            </div>
            <!--<div class="fa fa-twitter wtt-mark"></div>-->

            <div class="media">
              <!--<a href="#">-->
              <!--<img class="align-self-center rounded-circle mr-3" style="width:85px; height:85px;" alt="" src="images/admin.jpg">-->
              <!--</a>-->
              <div class="media-body">
                <p class="text-light">{{$t('seldashboard.storeStatTitle')}}</p>
                <h2 class="text-white display-6">{{storeName}}</h2>
                <!--<p class="text-light">Project Manager</p>-->
              </div>
            </div>
          </div>
          <div class="twt-write col-sm-12  twt-category">
            <div class="row form-group">
              <div class="col col-md-3"><label for="select_store" class=" form-control-label">{{$t('seldashboard.selectStore')}}</label></div>
              <div class="col-12 col-md-9">
                <select id="select_store" v-model="selectedStore" class="form-control" name="selectedStore">
                  <option v-for="storeOption in storeOptions" :value="storeOption.value">{{storeOption.text}}</option>
                </select>
              </div>
            </div>


          </div>
          <div class="weather-category">
            <ul>
              <!--  <li class="active">
                 {{$t('seldashboard.actualDayIncome')}}
                 <h5>{{storeActualDayIncome}}</h5>
               </li>
               <li>
                 {{$t('seldashboard.actualDayIncomeByCash')}}
                 <h5>{{storeActualDayIncomeByCash}}</h5>
               </li>
               <li>
                 {{$t('seldashboard.actualDayIncomeByCard')}}
                 <h5>{{storeActualDayIncomeByCard}}</h5>
               </li>
               <li>
                 {{$t('seldashboard.actualMonthIncome')}}
                 <h5>{{storeActualMonthIncome}}</h5>
               </li>
               <li>
                 {{$t('seldashboard.lastMonthIncome')}}
                 <h5>{{storeLastMonthIncome}}</h5>
               </li>
               -->
              <li>
                {{$t('seldashboard.storeSumProfit')}}
                <h5>{{storeSumProfit}}</h5>
              </li>
              <li>
                {{$t('seldashboard.storeSumIncome')}}
                <h5>{{storeSumIncome}}</h5>
              </li>
              <li>
                {{$t('seldashboard.storeSumExpense')}}
                <h5>{{storeSumExpense}}</h5>
              </li>
              <li>
                {{$t('seldashboard.storeSumProductSell')}}
                <h5>{{storeSumProductSell}}</h5>
              </li>
              <li>
                {{$t('seldashboard.storeClosesCashRegisterOpeningBalances')}}
                <h5>{{storeClosesCashRegisterOpeningBalances}}</h5>
              </li>
              <li>
                {{$t('seldashboard.storeClosesCashRegisterClosingBalances')}}
                <h5>{{storeClosesCashRegisterClosingBalances}}</h5>
              </li>

              <li>
                {{$t('seldashboard.storeSumProductSellCash')}}
                <h5>{{storeSumProductSellCash}}</h5>
              </li>
              <li>
                {{$t('seldashboard.storeSumProductSellCard')}}
                <h5>{{storeSumProductSellCard}}</h5>
              </li>
              <li>
                {{$t('seldashboard.storeSumProductSellTransfer')}}
                <h5>{{storeSumProductSellTransfer}}</h5>
              </li>
              <template v-if="Helper.hasModuleRights(moduleRights, 5,[1,2,3,4,5,6,7,8,9,10])">
                <li v-if="Array.isArray(lastLogin)&&lastLogin.length>0&& lastLogin[0].maxdt">
                  {{$t('seldashboard.lastLogin')}}
                  <h5>{{lastLogin[0].real_name + " (" + lastLogin[0].user_name + ")"}}</h5>
                  <h5>{{Helper.getDisplaUTCDateTime(lastLogin[0].maxdt, "HH:mm:ss")}}</h5>
                </li>
              </template>
            </ul>
          </div>
          <footer class="twt-footer">
            <!--<a href="#"><i class="fa fa-camera"></i></a>-->
            <!--<a href="#"><i class="fa fa-map-marker"></i></a>-->
            <!--New Castle, UK-->
            <!--<span class="pull-right">-->
            <!--32-->
            <!--</span>-->
          </footer>
        </section>
      </div>

      <!--<div class="col-xl-3 col-lg-6">xxx1</div>-->
      <!--<div class="col-xl-3 col-lg-6">xxx2</div>-->
      <!--<div class="col-xl-3 col-lg-6">xxx3</div>-->
    </div>


  </div>


</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
//  import HelloI18n from '@/components/HelloI18n.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import moment from 'moment';

  export default {
    name: 'SelDashboard',
    data(){
      return {
        moduleRights: []
        , moduleRightsIds: []

        , companyName: ""
        , actualDayIncome: ""
        , actualDayIncomeByCash: ""
        , actualDayIncomeByCard: ""
        , actualDayIncomeByTransfer: ""
        , lastMonthIncome: ""
        , actualMonthIncome: ""
        , lastThreeMonthGrowing: ""

        , totalBuyers: ""
        , totalProducts: ""
        , totalStores: ""
        , totalUsers: ""

        , store: ""
        , stores: ""
        , storeOptions: ""

        , selectStore: ""
        , selectedStore: ""
        , storeName: ""
        , storeLastMonthIncome: ""
        , storeActualDayIncome: ""
        , storeActualDayIncomeByCash: ""
        , storeActualDayIncomeByCard: ""
        , storeActualDayIncomeByTransfer: ""
        , storeActualMonthIncome: ""
        , lastLogin: []
        , Helper: Helper


        , sumProfit: "-"
        , sumIncome: "-"
        , sumExpense: "-"
        , sumProductSell: "-"
        , sumProductSellCash: "-"
        , sumProductSellCard: "-"
        , sumProductSellTransfer: "-"
        , sumIncomeActualMonth: "-"
        , sumIncomePrevMonth: "-"

        , storeSumProfit: "-"
        , storeSumIncome: "-"
        , storeSumExpense: "-"
        , storeSumProductSell: "-"
        , storeSumProductSellCash: "-"
        , storeSumProductSellCard: "-"
        , storeSumProductSellTransfer: "-"
        , storeClosesCashRegisterOpeningBalances: "-"
        , storeClosesCashRegisterClosingBalances: "-"

      }
    },
    mounted() {
      const modul = this;
      modul.moduleRights = modul.$store.state.moduleRights;
      modul.roles = [2, 3, 4, 5, 6, 7, 8, 9, 10];
      const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
      if (!Helper.checkRoles(modul.roles, role)) {
        modul.$router.push({name: "login"})
      }
      modul.getSelDashboardData();
    },
    watch: {
      selectedStore: function (newStore, oldStore) {
        const modul = this;
        modul.refreshStoreStat(newStore);
      },
      '$store.state.user': function (newVal, oldVal) {
        const modul = this;
        const user_role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
        modul.user_role=user_role;
      },
      '$store.state.moduleRights': function (newVal, oldVal) {
        const modul = this;
        modul.moduleRights = newVal;

        if (Array.isArray(modul.moduleRights)) {
          modul.moduleRightsIds = [];
          modul.moduleRights.forEach(function (e, i) {
            if (Number(e.id_rights) > 0) {
              modul.moduleRightsIds.push(e.modulid)
            }
          })
        }
      },
    },
    methods: {
      getSelDashboardData(){
        const modul = this;
        const data = {};

        data.dashboardVersion = 2;
        const actualDt=moment().subtract(0,"hours");
        data.periodDtFrom = actualDt.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtTo = actualDt.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtActualMonthFrom = actualDt.clone().startOf('month').utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtActualMonthTo = actualDt.clone().endOf('month').utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtPreviousMonthFrom = actualDt.clone().startOf('month').subtract(1,"months").utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtPreviousMonthTo = actualDt.clone().endOf('month').subtract(1,"months").utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtPreviousMinus3MonthFrom = actualDt.clone().startOf('month').subtract(3,"months").utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtPreviousMinus3MonthTo = actualDt.clone().endOf('month').subtract(3,"months").utc().format('YYYY-MM-DD HH:mm:ss');


        Api.getSelDashboardData(data).then(function (res) {
          if (res && res.result) {
            modul.companyName = res.companyName;

            // dashboardVersion = 2;
            modul.sumProfit = (res.sumProfit)?res.sumProfit:"-";
            modul.sumIncome = (res.sumIncome)?res.sumIncome:"-";
            modul.sumExpense = (res.sumExpense)?res.sumExpense:"-";
            modul.sumProductSell = (res.sumProductSell)?res.sumProductSell:"-";
            modul.sumProductSellCash = (res.sumProductSellCash)?res.sumProductSellCash:"-";
            modul.sumProductSellCard = (res.sumProductSellCard)?res.sumProductSellCard:"-";
            modul.sumProductSellTransfer = (res.sumProductSellTransfer)?res.sumProductSellTransfer:"-";
            modul.sumIncomeActualMonth = (res.sumIncomeActualMonth)?res.sumIncomeActualMonth:"-";
            modul.sumIncomePrevMonth = (res.sumIncomePrevMonth)?res.sumIncomePrevMonth:"-";

            modul.lastMonthIncome = res.sumIncomePrevMonth;
            modul.actualDayIncome = res.sumIncome;
            modul.actualDayIncomeByCash = res.sumProductSellCash;
            modul.actualDayIncomeByCard = res.sumProductSellCard;
            modul.actualDayIncomeByTransfer = res.sumProductSellTransfer;
            modul.actualMonthIncome = res.sumIncomeActualMonth;
            modul.lastThreeMonthGrowing = "-"; // res.lastThreeMonthGrowing; // in Percentage


//            modul.lastMonthIncome = res.lastMonthIncome;
//            modul.actualDayIncome = res.actualDayIncome;
//            modul.actualDayIncomeByCash = res.actualDayIncomeByCash;
//            modul.actualDayIncomeByCard = res.actualDayIncomeByCard;
//            modul.actualMonthIncome = res.actualMonthIncome;
//            modul.lastThreeMonthGrowing = res.lastThreeMonthGrowing; // in Percentage
//
            modul.totalBuyers = res.totalBuyers;
            modul.totalProducts = res.totalProducts;
            modul.totalStores = res.totalStores;
            modul.totalUsers = res.totalUsers;
          }
        });
        Api.getStores().then(function (res) {
          if (res && res.result) {
            modul.stores = res.data;
            if (!modul.store) {
              modul.store = (modul.stores[0]) ? modul.stores[0] : {};
              modul.selectedStore = (modul.stores[0] && modul.stores[0].id) ? modul.stores[0].id : 0;
            }
            modul.storeOptions = modul.generateOptions(modul.stores);
            modul.refreshStoreStat();
          }
        });
      },
      refreshStoreStat(newStore){
        const modul = this;
        let id = (modul.store.id) ? modul.store.id : 0;
        if (newStore) {
          id = newStore;
        }
        const data = {id_store: id};
//        data.todayfrom = moment.utc().format('YYYY-MM-DD 00:00:00');
//        data.todayto = moment.utc().add(1, 'days').format('YYYY-MM-DD 00:00:00');
        data.dashboardVersion = 2;
        const actualDt=moment().subtract(0,"hours");
        data.periodDtFrom = actualDt.clone().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtTo = actualDt.clone().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtActualMonthFrom = actualDt.clone().startOf('month').utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtActualMonthTo = actualDt.clone().endOf('month').utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtPreviousMonthFrom = actualDt.clone().startOf('month').subtract(1,"months").utc().format('YYYY-MM-DD HH:mm:ss');
        data.periodDtPreviousMonthTo = actualDt.clone().endOf('month').subtract(1,"months").utc().format('YYYY-MM-DD HH:mm:ss');
        Api.getSelStatByStore(data).then(function (res) {
          if (res && res.result) {
            modul.storeName = res.storeName;

            modul.storeLastMonthIncome = res.lastMonthIncome;

            modul.storeActualDayIncome = res.sumIncome;
            modul.storeActualDayIncomeByCash = res.actualDayIncomeByCash;
            modul.storeActualDayIncomeByCard = res.actualDayIncomeByCard;
            modul.storeActualMonthIncome = res.actualMonthIncome;



            modul.storeSumProfit = res.storeSumProfit;
            modul.storeSumIncome = res.storeSumIncome;
            modul.storeSumExpense = Math.abs(Number(res.storeSumExpense));
            modul.storeSumProductSell = res.storeSumProductSell;
            modul.storeSumProductSellCash = res.storeSumProductSellCash;
            modul.storeSumProductSellCard = res.storeSumProductSellCard;
            modul.storeSumProductSellTransfer = res.storeSumProductSellTransfer;
            modul.storeClosesCashRegisterOpeningBalances = res.storeClosesCashRegisterOpeningBalances;
            modul.storeClosesCashRegisterClosingBalances = Math.abs(Number(res.storeClosesCashRegisterClosingBalances));
            console.log("-----------------modul.storeSumProfit");
            console.log(modul.storeSumProfit);
            console.log("-----------------res");
            console.log(res);
//
//            sumExpense: -100
//            sumIncome: 530
//            sumProductSell: 450
//            sumProductSellCard: 100
//            sumProductSellCash: 300
//            sumProductSellTransfer: 50
//            sumProfit: 430
//
//            Napi bevétel
//            Napi bevétel készpénzzel
//            Napi bevétel kártyával
//            Tárgyhavi bevétel
//            Utolsó lezárt havi bevétel

//            modul.storeLastMonthIncome = res.lastMonthIncome;
//            modul.storeActualDayIncome = res.actualDayIncome;
//            modul.storeActualDayIncomeByCash = res.actualDayIncomeByCash;
//            modul.storeActualDayIncomeByCard = res.actualDayIncomeByCard;
//            modul.storeActualMonthIncome = res.actualMonthIncome;
            modul.lastLogin = res.lastLogin;
          }
        });
      },
      generateOptions(stores){
        const ret = [];
        if (Array.isArray(stores)) {
          stores.forEach(function (e) {
            const retElement = [];
            retElement['value'] = e.id;
            retElement['text'] = e.text;
            ret.push(retElement);
          })
        }
        return ret;
      },
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
//      HelloI18n,
      MenuToggle
    },
  };
</script>

<style scoped>
  .seldashboardRow .card {
    min-height: 100px;
  }
</style>






